export default "__VITE_ASSET__ZlFF65Hu__"